interface WeeklyNotesFieldProps {
  value: string;
  onChange: (value: string) => void;
  onSave: () => void;
  rows: number;
  placeholder: string;
  isPending: boolean;
  isSuccess: boolean;
  buttonClassName: string;
}

export const WeeklyNotesField = ({
  value,
  onChange,
  onSave,
  rows,
  placeholder,
  isPending,
  isSuccess,
  buttonClassName,
}: WeeklyNotesFieldProps) => (
  <>
    <textarea
      value={value}
      onChange={(event) => onChange(event.target.value)}
      rows={rows}
      className="w-full rounded-lg border border-slate-300 p-3 text-sm"
      placeholder={placeholder}
    />
    <div className="mt-2 flex items-center gap-3">
      <button type="button" onClick={onSave} disabled={isPending} className={buttonClassName}>
        {isPending ? 'Sparar…' : 'Spara'}
      </button>
      {isSuccess && <span className="text-sm text-green-600">Sparat</span>}
    </div>
  </>
);
